export default ({ axios, mapQueryString }) => ({
    index: (branch, query = {}) => axios.get(`/branches/${branch}/branch-goods${mapQueryString(query)}`)
})


// WEBPACK FOOTER //
// ./src/api/branchGoodsOrder.js